import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = ["yes", "no"] as const

export default function PastChanges() {
  return <SingleSelectPage translationKey="pastChanges" options={OPTIONS} />
}
